import type {
  LanguageQualification,
  OtherTestQualification,
  AcademicQualification,
  QualificationCheckRemarks,
} from '../../graphql';

export type UpdateQualificationCheckInput = {
  applicationId: string;
  remark?: QualificationCheckRemarks;
  academicQualification?: AcademicQualification[];
  languageQualification?: LanguageQualification[];
  otherTestQualification?: OtherTestQualification[];
};

export enum QualificationDetailMode {
  ADMIN_VERIFICATION,
  APPLICANT_VIEW,
  MONITOR_VIEW,
}
